"use strict";

var _createClass = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EndOfStreamError = exports.defaultMessages = void 0;
exports.defaultMessages = 'End-Of-Stream';
/**
 * Thrown on read operation of the end of file or stream has been reached
 */

var EndOfStreamError = /*#__PURE__*/function (_Error) {
  _inherits(EndOfStreamError, _Error);

  var _super = _createSuper(EndOfStreamError);

  function EndOfStreamError() {
    _classCallCheck(this, EndOfStreamError);

    return _super.call(this, exports.defaultMessages);
  }

  return _createClass(EndOfStreamError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.EndOfStreamError = EndOfStreamError;